import React from 'react';
import { Button, Stack, alpha, useTheme } from '@mui/material';
import { OpportunityInterestStatus } from '@inversor-hub/types';

interface OpportunityCTAProps {
  interestStatus?: OpportunityInterestStatus;
  onDeleteInterest: (e: React.MouseEvent) => void;
  onReserve: (e: React.MouseEvent) => void;
  onReject: (e: React.MouseEvent) => void;
  onGoToInvestment: (e: React.MouseEvent) => void;
}

export const OpportunityCTA: React.FC<OpportunityCTAProps> = ({
  interestStatus,
  onDeleteInterest,
  onReserve,
  onReject,
  onGoToInvestment,
}) => {
  const theme = useTheme();

  if (!interestStatus) return null;

  switch (interestStatus) {
    case 'PENDING':
      return (
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={onDeleteInterest}
          sx={{
            borderRadius: 2,
            fontWeight: 700,
            textTransform: 'none',
          }}
        >
          Ya no me interesa
        </Button>
      );

    case 'SELECTED':
      return (
        <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={onReserve}
            sx={{
              borderRadius: 2,
              fontWeight: 700,
              textTransform: 'none',
              flex: 1,
            }}
          >
            Reservar
          </Button>
          <Button
            variant="text"
            size="small"
            color="error"
            onClick={onReject}
            sx={{
              borderRadius: 2,
              fontWeight: 700,
              textTransform: 'none',
              minWidth: 'auto',
              px: 2,
              '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, 0.08),
              },
            }}
          >
            Rechazar
          </Button>
        </Stack>
      );

    case 'RESERVED':
      return (
        <Button
          variant="outlined"
          size="small"
          onClick={onGoToInvestment}
          sx={{
            borderColor: theme.palette.success.main,
            color: theme.palette.success.main,
            borderRadius: 2,
            fontWeight: 700,
            textTransform: 'none',
            '&:hover': {
              borderColor: theme.palette.success.dark,
              backgroundColor: alpha(theme.palette.success.main, 0.08),
            },
          }}
        >
          Ir a la inversión
        </Button>
      );

    default:
      return null;
  }
};
